/**
 * Model that represents our change data.
 * 
 * @package Ninja Forms builder
 * @subpackage Fields
 * @copyright (c) 2015 WP Ninjas
 * @since 3.0
 */
define( 'models/app/changeModel',[], function() {
	var model = Backbone.Model.extend( {
		defaults: {
			disabled: false
		}
	} );
	
	return model;
} );
